import { render, staticRenderFns } from "./CustomerFunding.vue?vue&type=template&id=3147565a&scoped=true"
import script from "./CustomerFunding.vue?vue&type=script&lang=ts"
export * from "./CustomerFunding.vue?vue&type=script&lang=ts"
import style0 from "./CustomerFunding.vue?vue&type=style&index=0&id=3147565a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3147565a",
  null
  
)

export default component.exports